import "./invoice.css";
import React from "react";

import InvoicePage from "./InvoicePage";
import InvoiceSummaryPage from "./invoiceSummaryPage";
import PaymentInformation from "./PaymentInformation";

const ITEMS_PER_PAGE = 12;

const InvoiceTemplate = ({ invoice }) => {

    const pages = [];

    for (
        let i = 0;
        i < invoice.items.length;
        i += ITEMS_PER_PAGE
    ) {
        pages.push(
            invoice.items.slice(i, i + ITEMS_PER_PAGE)
        );
    }

    // Kapag puno ang last page, ilagay ang summary sa sariling page
    const separateSummary =
        pages.length > 0 &&
        pages[pages.length - 1].length === ITEMS_PER_PAGE;

    const totalPages =
        pages.length +
        (separateSummary ? 1 : 0) +
        1; // Payment Page

    return (
        <>
            {pages.map((items, index) => (
                <InvoicePage
                    key={index}
                    invoice={invoice}
                    items={items}
                    pageNumber={index + 1}
                    totalPages={totalPages}
                    showSummary={
                        !separateSummary &&
                        index === pages.length - 1
                    }
                />
            ))}

            {separateSummary && (
                <InvoiceSummaryPage
                    invoice={invoice}
                    pageNumber={pages.length + 1}
                    totalPages={totalPages}
                />
            )}

            <PaymentInformation
                pageNumber={totalPages}
                totalPages={totalPages}
            />
        </>
    );
};

export default InvoiceTemplate;